import def from "csi/def";
import FieldConstructor from "csi/def/Field";
import Widget from "csi/form/Widget";
import locale from "csi/locale";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const EngineeringChangeForm = declare(Widget, {

	nodeNameField: "Engineering Change",
	idName: "Node Name",

	/** @property {Names} productStore- the store based on the current Node either Style / Material / FormulatedMaterial/ Materials on MSG */
	productStore: null,

	/** @property {string} productLabel- the id for the label on form accroding to current Node either Style / Material */
	productLabel: null,

	/**
	 * @override
	 * Insert Style / Material / FormulatedMaterial dropdown field if it doesn't already exist
	 */
	_resolveView() {
		const ecNodeField = this.defView.getField("Node Name");
		if (ecNodeField) {
			ecNodeField.m_bRequired = true;
		} else {
			this.insertField(lang.mixin(new FieldConstructor(), {
				m_id: this.idName,
				m_bRequired: true,
			}));
		}
		/**
		 * 	Style dropdown on the Engineering Change form on all StrutureItem Levels expect for site level.
		 *  Material dropdown on the Engineering Change form on Materials & MSG
		 */
		if (this.productStore) {
			this.insertField(lang.mixin(new FieldConstructor(), {
				m_label: locale.type(this.productLabel),
				m_name: this.productLabel,
				m_typeControl: def.FIELD_MULTI_SELECT,
				m_bRequired: true,
			}));
		}
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Modified the store for field to display style / material / formulatedmaterial dropdown values
	 */
	getFieldStore(field, value) {
		if (field.getControlName() === this.productLabel) {
			return this.productStore;
		}
		return this.inherited(arguments);
	},
});

export = EngineeringChangeForm;